export default __webpack_public_path__ + "static/media/fad-slider-round-3.b965a575.svg";